<template>
    <div :class="{section: true, start: true, mobile: mobile()}">
        <h1 class="title">Warum feiern wir Weihnachten?</h1>
        <img class="santa" src="@/assets/christmas/santa.svg">
        <img class="cloud1" src="@/assets/christmas/cloud1.svg">
        <img class="cloud2" src="@/assets/christmas/cloud2.svg">
        <img class="scroll" src="@/assets/christmas/scroll.svg" @click="$emit('next')">
        <img class="circle" :style="getStyle()" src="@/assets/christmas/startCircle.svg" @click="$emit('next')">
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent.js";

    @Component()
    export default class Start extends BasicComponent {

        onActive() {

        }

        mounted() {
            this.register();
        }

        getStyle() {
            const circleWidth = this.getCircleWidth();
            return {
                width: circleWidth + 'px',
                transform: "translate(-50%, " + (circleWidth - this.getWindowHeight()/10) + "px)"
            };
        }

        getCircleWidth() {
            return 2*this.getCircleRadius(this.getWindowWidth(), this.getWindowHeight()/10);
        }

    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .start {
        background-color: white;
        overflow: hidden !important;
        position: relative;

        .title {

            font-size: 60px;

            width: 100%;
            max-width: 500px;
            color: #000336;
            text-align: center;
            font-weight: bold;

            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -5vw);
        }

        .santa {
            width: 30vw;
            position: absolute;
            top: 15vh;
            left: 20vw;
            z-index: 100;
        }

        .cloud1 {
            width: 20vw;
            position: absolute;
            left: 10vw;
            top: 25vh;
        }

        .cloud2 {
            position: absolute;
            width: 18vw;
            top: 30vh;
            right: 10vw;

        }

        .scroll {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            z-index: 1010;

            &:hover {
                cursor: pointer;
            }
        }

        .circle {
            position: absolute;

            left: 50%;
            bottom: 0;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .mobile {
        .title {
            font-size: 10vw;
            transform: translate(-50%, -50%);
            z-index: 200;
        }

        .santa {
            width: 50vw;
        }

        .cloud1 {
            width: 30vw;
        }

        .cloud2 {
            width: 29vw;
            top: 25vh;
        }

        .circle {
            bottom: 50px;
        }
    }

</style>
